module.exports = __webpack_public_path__ + "static/sport/login.f62dcf9.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport6/login.gif
// module id = J9/x
// module chunks = 0